import type { MailboxInfo } from 'owa-client-types';
import { setItem, type LocalStorageKeys } from 'owa-local-storage';

const OFFLINE_CONTACTS_FALLBACKONLINE_ENABLED_KEY = 'OWA-OFFLINE-CONTACTS-FALLBACKNOPGAL';
const OFFLINE_CONTACTS_FALLBACKONLINE_ENABLED_IN_SESSION_KEY =
    'OWA-OFFLINE-CONTACTS-FALLBACKNOPGAL-SESSION';

export function getFallbackToNOPGALLocalStorageKey(mailboxInfo: MailboxInfo): LocalStorageKeys {
    return `${OFFLINE_CONTACTS_FALLBACKONLINE_ENABLED_KEY}-${mailboxInfo.sourceId}`;
}

export function getFallbackToNOPGALInSessionStorageKey(mailboxInfo: MailboxInfo): LocalStorageKeys {
    return `${OFFLINE_CONTACTS_FALLBACKONLINE_ENABLED_IN_SESSION_KEY}-${mailboxInfo.sourceId}`;
}

export function toggleOfflineNoPGAL(mailboxInfo: MailboxInfo, value: string): void {
    setItem(self, getFallbackToNOPGALLocalStorageKey(mailboxInfo), value);
}

export function toggleOfflineNoPGALForOutlookSession(
    mailboxInfo: MailboxInfo,
    sessionId: string
): void {
    setItem(self, getFallbackToNOPGALInSessionStorageKey(mailboxInfo), sessionId);
}
